import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '여러분은 오늘날의 카메라가 단순히 영상을 녹화하는 것뿐만 아니라, 보고 있는 것을 \'이해\'할 수 있다는 것을 알고 계신가요? 이것이 바로 AI Camera의 힘입니다. AI Camera는 우리가 주변 세계를 감시하고, 보호하며, 상호작용하는 방식을 변화시키고 있는 기술의 진보입니다. 그렇다면 AI Camera란 무엇이고, 어떻게 작동하며, 어떤 이점을 제공할까요? 이 글을 통해 스마트 카메라 기술에 대해 더 자세히 알아봅시다!',
  keywords: 'AI Camera, 스마트 카메라, AI 보안 카메라, AI 감시 카메라, AI Camera 응용',
  ogSite: 'AI Camera란 무엇이며, 어떤 기능이 있나요?',
  title: 'AI Camera란 무엇이며, 어떤 기능이 있나요?',
  ogUrl: 'https://orbro.io/blog/what-is-ai-camera',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_HbJHmrWNscIQ36wsZysV5prEJWi86NHyeCvQn5vyoS_O_QOMJRlEoVIREjk1x7cyfZV4ZhQBngw1-54DmmpIw5Q28zBk-9flTH5FsUnn85xLla0xcxUc0pGXdEjkQva4Vop1B4b7vFya9u2-zD5Hr6p5FGrUfsaBm8uzdloI3l7yiEdJxeT5VVSkUkaEc2dpewFPBQtlTU2Zeq1C6evX6Wl4fGgVRf4fegH29_y5uvzFSSDM4nmlQpAUi325plJywuxuocCMpp3sbG0qDST-qkZpMrLmp7ib17kd2nq5GWWhVOgtVgL4gDjruzCMNG41J8lyZwH51nA9LNmKHQci89Q7WUkebfkVQxXFmeCOXFP8aze_V8byelJoR0z9Yb7CpIETqx8Y_m-OjklHd4lYXSMyJmWVTm21UiIIBFxJOiSiB-HX7ZY2boZ6liqJDVXR0Pv2p3knVkZQ7BLODVkJF7CYx_BaJs4KyrdGQ3LFsSlxT-wrkyttGEWa2UkI2rN-q-3ceZqGyjodzigrJmGuPS6ALjST1dc6RTnPwuS9F0WGvqF20Tst0cH8U1pUJjJTPSgfWIRRDfsTPAPYDJIHZD7O3iJPndAGHCLUkAWjnN71J32rDhF4dJ3_2RtTBHTI0v-FCwYahjQYTS0EBBNtgOIPjRDPBkdNy-jO52KdPThxht5uQydbQqboj-DZFE_b-oebtMxf9LZiooZP4KdRkHEk_0i4k6o47hqdSAffCLtzcyQipYd28UF8OSH4d2kG_T28_nxjE7wuvATmXG4GnkAxTI5go-PwilFE-KHFlQb1mwCf5gZgNcHTZ4c1XpW3tgljPVhQr6651GvrpR2XIxHOC0mF0M6OLuRazDWdy-g-T9S1DbLBxtzGrnSPGW1Q1mhWgDq-s8usPXxJqW_TNBJruyyK95HEieiXueKjwTE_ximqUqZBQvN-91eglWnj0S-BH61Le8NtGPlUp2cbyDYlcO8OU_CGwLV2acVzk0N3bDI1KV8b_fck2HKAkD-JNtLMAzhojJwMQdOaSP86zJ2_eBdIi7UEJdkY5cMdoHOLmVpQxwpGvPbGnyHmkPevePmMkzcQt_313Goy0klityTqej0TFnqSrBYw3nZm4gFJAUL4pzOWbOkmBPLsR0RYQHJsB0Z3LkqyMb6dqYd_g8kVYyibLhYWbcFvzmo-StrgSmVTbjjxZQTUt3YTzBwCTdhS4eShKOPkhQPizcIXvEIUoZJJE6FeSNfIcWQYlcwhT8yJ5Tyxdph93HZ7WS4lwXObdhWyWXDIeAXih04qFHe16-3Ap_MGW3x_Ap04ivS-lYTRbmyc2Y0bINo5xupgI0Fs1v1V2Re1f3_N2JSWJ5yHEKuhdkbRGDfWEkZHdT_NSvDdSKshOMMFh2xp8UHScL1JL3GV_qn8zm--80BzClZSo2qe5KuEuLmCvHVIqlYkzMfuWjgMcPdaLPEt-fzUIJ2cVMGPBcpXPqDaZ8ea1hdIEJOnqYlxvD0HqjjCf7-XxGkNeZUi5fWPd9AHlRwOFxMtrZggYhb9eWIAjyttB9zT3rpxSm_BoNpvLK4uWcyyA8sQtoHaxk0J5M9-XmZZWLVfOOW1mt0LZa-jgc6J11aQrvgox79Z_l-Q=w1502-h1410?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-07-07',
  tag1: '#AICamera',
  tag2: '#스마트카메라',
  tag3: '#AI보안카메라',
  tag4: '#AI감시카메라',
  text: [
    {
      head: '',
      subHead: '',
      desc: '여러분은 오늘날의 카메라가 단순히 영상을 녹화하는 것뿐만 아니라, 보고 있는 것을 \'이해\'할 수 있다는 것을 알고 계신가요? 이것이 바로 AI Camera의 힘입니다. AI Camera는 우리가 주변 세계를 감시하고, 보호하며, 상호작용하는 방식을 변화시키고 있는 기술의 진보입니다. 그렇다면 AI Camera란 무엇이고, 어떻게 작동하며, 어떤 이점을 제공할까요? 이 글을 통해 스마트 카메라 기술에 대해 더 자세히 알아봅시다!',
      dot: ''
    },
    {
      head: '1. What is Ai Camera (AI Camera란 무엇인가)?',
      subHead: '',
      desc: 'AI Camera(Artificial Intelligence Camera)는 인공지능(AI)과 머신러닝 알고리즘이 통합된 카메라로, 실시간으로 영상을 분석하고 처리할 수 있습니다. 전통적인 카메라가 단순히 영상을 녹화하는 데 그친다면, AI Camera는 얼굴 인식, 움직임 감지, 행동 분석 등 장면에서 일어나는 일을 \'보고\' \'이해\'할 수 있습니다. AI 덕분에 이 카메라는 인간의 개입 없이 자동으로 결정을 내리거나 경고를 보낼 수 있습니다.\n\nAI Camera는 보안, 감시, 자동화 시스템에 주로 통합되어 다양한 분야에서 효율성과 정확성을 높이는 데 기여합니다.\n\n예시: 스마트 홈의 AI Camera는 집주인의 얼굴을 인식하고 열쇠 없이도 자동으로 문을 열어줍니다.',
      dot: ''
    },
    {
      head: '2. AI Camera는 어떻게 작동하나요?',
      subHead: '',
      desc: 'AI Camera의 작동 방식을 이해하기 위해 다음 과정을 살펴봅시다.\n\n• 영상 수집: 카메라가 주변 환경에서 비디오나 이미지를 수집합니다.\n\n• AI 처리: AI 기술이 영상 데이터를 분석하고, 머신러닝 알고리즘을 사용해 특정 물체, 행동, 사건을 인식합니다.\n\n• 결정 또는 경고: 분석 결과를 바탕으로 AI Camera는 자동으로 알림을 보내거나, 경보를 울리거나, 중요한 데이터를 저장합니다.\n\n• 자기 학습 및 개선: 머신러닝 덕분에 AI Camera는 새로운 데이터를 통해 지속적으로 학습하며 시간이 지날수록 정확도가 향상됩니다.\n\n이 과정은 거의 즉각적으로 이루어져 AI Camera가 상황에 빠르고 스마트하게 대응할 수 있도록 합니다.\n\n예시: 매장에서 AI Camera는 절도 행위를 감지하고 즉시 보안 요원에게 경고를 보냅니다.',
      dot: ''
    },
    {
      head: '3. AI Camera의 주요 유형',
      subHead: '',
      desc: 'AI Camera는 다양한 요구를 충족하도록 설계된 여러 유형이 있습니다. 다음은 그중 일부입니다.\n\n• AI 보안 카메라\n기능: 감시, 얼굴 인식, 비정상적인 움직임 감지.\n응용: 주택, 사무실, 산업 단지.\n예시: 얼굴 인식으로 자동으로 문을 여는 카메라.\n\n• AI 교통 카메라\n기능: 교통량 추적, 위반 감지, 번호판 인식.\n응용: 도로, 스마트 주차장.\n예시: 신호 위반 차량을 자동으로 기록하고 관련 기관에 정보를 전송하는 카메라.\n\n• AI 소매 카메라\n기능: 고객 행동 분석, 인원 계수, 단골 고객 인식.\n응용: 상점, 슈퍼마켓, 쇼핑몰.\n예시: 고객이 많은 구역을 추적해 상품 배치를 조정하는 카메라.',
      dot: ''
    },
    {
      head: '4. 현대 생활에서 AI Camera의 역할',
      subHead: '',
      desc: 'AI Camera는 단순한 녹화 장치를 넘어 다양한 실질적인 가치를 제공하는 스마트 도구입니다.\n\n• 보안 및 안전 강화\nAI Camera는 지속적인 감시를 통해 사고를 적시에 감지하고 예방합니다.\n예시: 집 안의 AI Camera가 침입자를 감지하고 즉시 경보를 울립니다.\n\n• 관리 및 운영 최적화\n행동과 유동량에 대한 상세한 데이터를 제공해 기업이 스마트한 결정을 내릴 수 있도록 돕습니다.\n예시: 슈퍼마켓에서 AI Camera를 사용해 피크 시간을 분석하고 인력을 적절히 배치합니다.\n\n• 스마트 홈 자동화\n다른 스마트 기기와 연결되어 편리한 생활 경험을 제공합니다.\n예시: AI Camera가 집에 도착한 것을 인식하고 선호에 맞게 온도와 조명을 자동으로 조절합니다.',
      dot: ''
    },
    {
      head: '5. AI Camera의 실제 응용',
      subHead: '',
      desc: 'AI Camera는 다양한 산업에서 널리 사용되고 있습니다.\n\n• 공공 안전: 교통 감시, 사고 감지.\n\n• 소매: 고객 행동 분석을 통한 비즈니스 최적화.\n\n• 스마트 홈: 가정 내 기기를 자동으로 제어.\n\n예시: 스마트 시티에서 AI Camera를 사용해 교통 상황을 모니터링하고 신호등을 자동으로 조정합니다.',
      dot: ''
    },
    {
      head: '6. 결론',
      subHead: '',
      desc: 'AI Camera는 감시 기술의 진보를 넘어 보안, 자동화, 스마트 사용자 경험의 미래를 여는 열쇠입니다. 가정 보호에서 비즈니스 최적화에 이르기까지 AI Camera는 우리가 살고 일하는 방식을 변화시키고 있습니다. 안전과 효율성을 높이고 싶다면 오늘 바로 AI Camera를 도입해 보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
    ],
  },
};
